"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var uuid_1 = require("uuid");
var ChannelStorage_1 = __importDefault(require("./ChannelStorage"));
var ChatClient_1 = __importDefault(require("./ChatClient"));
var ChatMemoryStorageAdapter_1 = __importDefault(require("./ChatMemoryStorageAdapter"));
var DEFAULT_ENDPOINT = 'http://localhost:4000';
var ChatService = /** @class */ (function () {
    function ChatService(endpoint, token) {
        var _this = this;
        this.chatMemoryStorageAdapter = new ChatMemoryStorageAdapter_1.default();
        this.chatClient = new ChatClient_1.default(endpoint, token);
        this.channelsStorage = new ChannelStorage_1.default();
        this.lastActingType = null;
        this.lastActingAt = null;
        this.currentActiveChannel = null;
        this.chatClient.onAllNewMessage(function (message) { return __awaiter(_this, void 0, void 0, function () {
            var channelMessageStorage;
            var _a;
            return __generator(this, function (_b) {
                if (message.channelId) {
                    channelMessageStorage = this.channelMessageStorage(message.channelId);
                    if (channelMessageStorage.initialMessagesLoaded &&
                        ((_a = this.currentActiveChannel) === null || _a === void 0 ? void 0 : _a.id) !== message.channelId) {
                        channelMessageStorage.addLiveMessage([message]);
                    }
                }
                return [2 /*return*/];
            });
        }); });
        this.chatClient.onChannelUpdate(function (channel) { return __awaiter(_this, void 0, void 0, function () {
            var currentUser, oldChannel, updatedChannel;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!channel) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.currentUser()];
                    case 1:
                        currentUser = _c.sent();
                        return [4 /*yield*/, this.channelsStorage.get(channel.id, this.chatClient)];
                    case 2:
                        oldChannel = _c.sent();
                        updatedChannel = __assign(__assign({}, oldChannel), channel);
                        if (!(((_a = this.currentActiveChannel) === null || _a === void 0 ? void 0 : _a.id) !== channel.id &&
                            ((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.senderId) !== currentUser.id)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.chatClient.getUnreadMessageCount(channel)];
                    case 3:
                        // if the channel is open then mark this message as read
                        updatedChannel = _c.sent();
                        _c.label = 4;
                    case 4:
                        this.channelsStorage.update(updatedChannel);
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        this.chatClient.onChannelUpsert(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var channel, error_1, _a, channelMembership, channelMemberships, rest, nChannel;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.channelsStorage.get(data.channelId, this.chatClient, { skipEmpty: true })];
                    case 1:
                        channel = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _d.sent();
                        // channel not found
                        return [2 /*return*/];
                    case 3:
                        _a = data.upsert, channelMembership = _a.channelMembership, channelMemberships = _a.channelMemberships, rest = __rest(_a, ["channelMembership", "channelMemberships"]);
                        nChannel = __assign(__assign({}, channel), rest);
                        if (channelMemberships) {
                            nChannel.channelMemberships = (_b = channel.channelMemberships) === null || _b === void 0 ? void 0 : _b.map(function (cm) {
                                var nChannelMembership = channelMemberships.find(function (cm2) { return cm2.id === cm.id; });
                                return __assign(__assign({}, cm), nChannelMembership);
                            });
                        }
                        if (channelMembership) {
                            nChannel.channelMemberships = (_c = channel.channelMemberships) === null || _c === void 0 ? void 0 : _c.map(function (cm) {
                                if (cm.id === (channelMembership === null || channelMembership === void 0 ? void 0 : channelMembership.id)) {
                                    return __assign(__assign({}, cm), channelMembership);
                                }
                                return cm;
                            });
                        }
                        this.channelsStorage.update(nChannel);
                        return [2 /*return*/];
                }
            });
        }); });
        this.chatClient.onChannelCreate(function (channel) {
            if (channel && channel.lastMessage)
                _this.channelsStorage.update(channel);
        });
        this.chatClient.onChannelDelete(function (channel) {
            if (channel)
                _this.channelsStorage.remove(channel.id);
        });
        this.chatClient.onConnect(function () {
            //TODO for all listed and watched channels load missed messages
        });
        this.chatClient.onReconnect(function () {
            _this.channelsStorage.setMaxRetryAttemptsReached(false);
            _this.channelsStorage.sortedChannels().forEach(function (channel) {
                _this.channelMessageStorage(channel.id)
                    .sortedMessages()
                    .filter(function (m) { return m.isQueued && !m.isRetriable; })
                    .forEach(function (message) {
                    _this.retryMessage(message);
                });
            });
        });
        this.chatClient.onMaxRetryAttemptsReached(function () {
            _this.channelsStorage.sortedChannels().forEach(function (channel) {
                _this.channelMessageStorage(channel.id).markAllQueuedMessagesAsRetriable();
            });
            _this.channelsStorage.setMaxRetryAttemptsReached(true);
        });
        this.chatClient.onUserActing(function (_a) {
            var channelId = _a.channelId, userId = _a.userId, lastActingAt = _a.lastActingAt, actingType = _a.actingType;
            return __awaiter(_this, void 0, void 0, function () {
                var channel, nChannelMemberships;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.channelsStorage.get(channelId, this.chatClient)];
                        case 1:
                            channel = _b.sent();
                            if (channel.channelMemberships) {
                                nChannelMemberships = channel.channelMemberships.map(function (channelMemberShip) {
                                    if (channelMemberShip.userId === userId) {
                                        return __assign(__assign({}, channelMemberShip), { lastActingAt: lastActingAt, lastActiingType: actingType });
                                    }
                                    return __assign({}, channelMemberShip);
                                });
                                this.channelsStorage.update(__assign(__assign({}, channel), { channelMemberships: nChannelMemberships }));
                            }
                            else {
                                console.warn('No memberships found for channel', channelId);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        });
        this.chatClient.onUserBlockChange(function (_a) {
            var userId = _a.userId, isBlocking = _a.isBlocking;
            _this.channelsStorage.sortedChannels().forEach(function (channel) {
                var _a;
                if ((_a = channel.channelMemberships) === null || _a === void 0 ? void 0 : _a.some(function (cm) { return cm.userId === userId; })) {
                    _this.channelsStorage.update(__assign(__assign({}, channel), { isBlockingMe: isBlocking }));
                }
            });
        });
        this.chatClient.onMessageDeleted(function (_a) {
            var channelId = _a.channelId, messageId = _a.messageId;
            _this.channelMessageStorage(channelId).softDeleteMessage(messageId);
        });
    }
    ChatService.getService = function (token, endpoint) {
        if (this.chatService && token === this.token) {
            return this.chatService;
        }
        if (this.chatService) {
            //TODO: disconnect and cleanup
        }
        this.token = token;
        this.chatService = new ChatService(endpoint || DEFAULT_ENDPOINT, token);
        return this.chatService;
    };
    ChatService.prototype.start = function () {
        //TODO: prevent double connect
        this.chatClient.connect();
    };
    ChatService.prototype.setCurrentActiveChannel = function (channel) {
        this.currentActiveChannel = channel;
    };
    ChatService.prototype.getCurrentActiveChannel = function () {
        return this.currentActiveChannel;
    };
    ChatService.prototype.channelMessageStorage = function (channelId) {
        return this.chatMemoryStorageAdapter.channelMessageStorage(channelId);
    };
    ChatService.prototype.getChannelStorage = function () {
        return this.channelsStorage;
    };
    ChatService.prototype.currentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.me()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ChatService.prototype.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    ChatService.prototype.getChannel = function (channelId) {
        return this.channelsStorage.get(channelId, this.chatClient);
    };
    ChatService.prototype.getChannelByExternalId = function (channelExternalId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.channelsStorage.getByExternalId(channelExternalId, this.chatClient)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ChatService.prototype.subscribeChannel = function (channelId) {
        var _this = this;
        var unsubscribeList = [];
        var unsubscribed = false;
        var channelMessageStorage = this.channelMessageStorage(channelId);
        this.channelsStorage
            .get(channelId, this.chatClient)
            .then(function (channel) { return __awaiter(_this, void 0, void 0, function () {
            var currentUser, lastMessageId, otherUserId, isBlockingMe, _a, blackList, lastReadMessageId, removeOnNewMessage, removeOnConnect;
            var _this = this;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (unsubscribed) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.currentUser()];
                    case 1:
                        currentUser = _g.sent();
                        lastMessageId = parseInt(((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.id) || '0', 10);
                        otherUserId = (_d = (_c = channel.channelMemberships) === null || _c === void 0 ? void 0 : _c.filter(function (cm) { return cm.userId !== currentUser.id; }).pop()) === null || _d === void 0 ? void 0 : _d.userId;
                        isBlockingMe = false;
                        if (!otherUserId) return [3 /*break*/, 4];
                        _a = isBlockingMe;
                        if (_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.chatClient.isBlockingMe(otherUserId)];
                    case 2:
                        _a = (isBlockingMe = _g.sent());
                        _g.label = 3;
                    case 3:
                        _a;
                        _g.label = 4;
                    case 4:
                        this.channelsStorage.sortedChannels().forEach(function (channel) {
                            var _a;
                            if ((_a = channel.channelMemberships) === null || _a === void 0 ? void 0 : _a.some(function (cm) { return cm.userId === otherUserId; })) {
                                _this.channelsStorage.update(__assign(__assign({}, channel), { isBlockingMe: isBlockingMe }));
                            }
                        });
                        return [4 /*yield*/, this.chatClient.getBlockedUsers()];
                    case 5:
                        blackList = _g.sent();
                        this.channelsStorage.setBlackList(blackList);
                        //Check if we need to join channel socket or the user channel is enough
                        //FIXME channel does not have listed & watching. Those property are from ChannelMembership.
                        if (channel.listed || channel.watching) {
                            if (!channelMessageStorage.latestDate()) {
                                //first time opening the channel. Load some messages
                                channelMessageStorage.loadEarlier(this.chatClient);
                            }
                            return [2 /*return*/, function () { }];
                        }
                        this.chatClient.joinChannel(channel.id);
                        unsubscribeList.push(function () {
                            _this.chatClient.leaveChannel(channel.id);
                        });
                        //if channel was previously opened and some messages are loaded then load the reset
                        if (channelMessageStorage.latestDate() &&
                            !channelMessageStorage.initialMessagesLoaded) {
                            channelMessageStorage.loadAllLater(this.chatClient);
                        }
                        else {
                            lastReadMessageId = ((_f = (_e = channel.channelMemberships) === null || _e === void 0 ? void 0 : _e.find(function (cm) { return cm.userId === currentUser.id; })) === null || _f === void 0 ? void 0 : _f.lastReadMessageId) || 0;
                            channelMessageStorage.loadEarlier(this.chatClient, channel.unreadMessageCount, lastReadMessageId);
                        }
                        removeOnNewMessage = this.chatClient.onNewMessage(channelId, function (message) {
                            var _a;
                            channelMessageStorage.addLiveMessage([message]);
                            // TODO setLastRecievedMessageId(channelId, message.id)
                            if (message.senderId !== currentUser.id &&
                                channelId === ((_a = _this.currentActiveChannel) === null || _a === void 0 ? void 0 : _a.id)) {
                                _this.markAllAsRead(channelId);
                            }
                        });
                        removeOnConnect = this.chatClient.onConnect(function () {
                            channelMessageStorage.loadAllLater(_this.chatClient);
                        });
                        unsubscribeList.push(removeOnNewMessage);
                        unsubscribeList.push(removeOnConnect);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (_error) {
            //throw error
        });
        return function () {
            // Following race condition may happens:
            // user subscrube to channel and we return the unsubscribe function
            // use unsubscribe before functions are pushed into unsubscribed list
            // In this case user will not be unsubscribed from OnNewMessage & OnConnect
            // To prevent this race condition we created unsubscribed flag
            unsubscribed = true;
            for (var i = 0; i < unsubscribeList.length; i++) {
                unsubscribeList[i]();
            }
        };
    };
    ChatService.prototype.subscribeChannelsUpdate = function () {
        var _this = this;
        var removeOnConnect = this.chatClient.onConnect(function () { return __awaiter(_this, void 0, void 0, function () {
            var archivedChannels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.getArchivedChannels()];
                    case 1:
                        archivedChannels = _a.sent();
                        this.channelsStorage.setArchivedChannels(archivedChannels);
                        this.channelsStorage.loadAllLater(this.chatClient);
                        return [2 /*return*/];
                }
            });
        }); });
        if (!this.channelsStorage.earliestDate()) {
            this.channelsStorage.loadEarlier(this.chatClient);
        }
        return function () {
            removeOnConnect();
        };
    };
    ChatService.prototype.sendMessage = function (channelId, messageType, content, metadata, replyTo) {
        return __awaiter(this, void 0, void 0, function () {
            var currentUser, localId, chatMessage;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentUser()];
                    case 1:
                        currentUser = _a.sent();
                        localId = uuid_1.v4();
                        chatMessage = {
                            localId: localId,
                            channelId: channelId,
                            messageType: messageType,
                            content: content,
                            postedAt: new Date(),
                            createdAt: new Date().toString(),
                            senderId: currentUser.id,
                            metadata: metadata,
                            replyToId: (replyTo === null || replyTo === void 0 ? void 0 : replyTo.id) || null,
                            replyTo: replyTo,
                        };
                        // store the message as queued for retries
                        this.channelMessageStorage(channelId).addLiveMessage([
                            __assign(__assign({}, chatMessage), { id: chatMessage.localId, isQueued: true, isRetriable: this.channelsStorage.maxRetryAttemptsReached }),
                        ]);
                        return [2 /*return*/, this.chatClient.sendMessage(chatMessage, function (onBlockedMessage) {
                                _this.channelMessageStorage(channelId).removeMessage(chatMessage.localId);
                            })];
                }
            });
        });
    };
    ChatService.prototype.retryMessage = function (message) {
        if (message.file) {
            return this.chatClient.sendAttachment(message, message.file);
        }
        return this.chatClient.sendMessage(message);
    };
    ChatService.prototype.triggerUserTyping = function (isTyping, channelExternalId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.triggerUserActing(isTyping, 'text', channelExternalId);
                return [2 /*return*/];
            });
        });
    };
    ChatService.prototype.triggerUserRecordingVoice = function (isRecording, channelExternalId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.triggerUserActing(isRecording, 'voice', channelExternalId);
                return [2 /*return*/];
            });
        });
    };
    ChatService.prototype.triggerUserRecordingVideo = function (isRecording, channelExternalId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.triggerUserActing(isRecording, 'video', channelExternalId);
                return [2 /*return*/];
            });
        });
    };
    ChatService.prototype.triggerUserActing = function (isActing, actingType, channelExternalId) {
        return __awaiter(this, void 0, void 0, function () {
            var channel, now;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChannelByExternalId(channelExternalId)];
                    case 1:
                        channel = _a.sent();
                        if (isActing) {
                            now = new Date();
                            if (this.lastActingAt === null ||
                                this.lastActingType !== actingType ||
                                utils_1.diffInSeconds(now, this.lastActingAt) > 5) {
                                this.lastActingAt = now;
                                this.lastActingType = actingType;
                                return [2 /*return*/, this.chatClient.triggerUserActing(isActing ? new Date() : null, channel.id, actingType)];
                            }
                        }
                        else if (this.lastActingAt !== null) {
                            this.lastActingAt = null;
                            return [2 /*return*/, this.chatClient.triggerUserActing(null, channel.id, actingType)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.markAllAsRead = function (channelId) {
        this.chatClient.emitMarkReadUntil(channelId);
    };
    ChatService.prototype.sendAttachment = function (channelId, messageType, content, file, replyTo) {
        return __awaiter(this, void 0, void 0, function () {
            var currentUser, localId, chatMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentUser()];
                    case 1:
                        currentUser = _a.sent();
                        localId = uuid_1.v4();
                        chatMessage = {
                            localId: localId,
                            channelId: channelId,
                            messageType: messageType,
                            content: content,
                            postedAt: new Date(),
                            createdAt: new Date().toString(),
                            senderId: currentUser.id,
                            file: file,
                            replyToId: (replyTo === null || replyTo === void 0 ? void 0 : replyTo.id) || null,
                            replyTo: replyTo,
                        };
                        // store the message as queued for retries
                        this.channelMessageStorage(channelId).addLiveMessage([
                            __assign(__assign({}, chatMessage), { id: chatMessage.localId, isQueued: true, isRetriable: this.channelsStorage.maxRetryAttemptsReached }),
                        ]);
                        return [2 /*return*/, this.chatClient.sendAttachment(chatMessage, file)];
                }
            });
        });
    };
    ChatService.prototype.loadEarlier = function (channelId) {
        var channelMessageStorage = this.channelMessageStorage(channelId);
        channelMessageStorage.loadEarlier(this.chatClient);
    };
    ChatService.prototype.loadLater = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var channelMessageStorage;
            return __generator(this, function (_a) {
                channelMessageStorage = this.channelMessageStorage(channelId);
                channelMessageStorage.loadLater(this.chatClient);
                return [2 /*return*/];
            });
        });
    };
    ChatService.prototype.getUser = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.getUser(id)];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    ChatService.prototype.blockUser = function (blockedId) {
        return __awaiter(this, void 0, void 0, function () {
            var blackList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.blockUser(blockedId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chatClient.getBlockedUsers()];
                    case 2:
                        blackList = _a.sent();
                        this.channelsStorage.setBlackList(blackList);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.unBlockUser = function (blockedId) {
        return __awaiter(this, void 0, void 0, function () {
            var blackList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.unBlockUser(blockedId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chatClient.getBlockedUsers()];
                    case 2:
                        blackList = _a.sent();
                        this.channelsStorage.setBlackList(blackList);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.archiveChannel = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var archivedChannels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.archiveChannel(channelId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chatClient.getArchivedChannels()];
                    case 2:
                        archivedChannels = _a.sent();
                        this.channelsStorage.setArchivedChannels(archivedChannels, channelId);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.unArchiveChannel = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var archivedChannels;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatClient.unArchiveChannel(channelId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chatClient.getArchivedChannels()];
                    case 2:
                        archivedChannels = _a.sent();
                        this.channelsStorage.setArchivedChannels(archivedChannels, channelId);
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatService.prototype.deleteMessage = function (messageId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.chatClient.deleteMessage(messageId)];
            });
        });
    };
    ChatService.prototype.loadEarlierChannels = function () {
        this.channelsStorage.loadEarlier(this.chatClient);
    };
    ChatService.prototype.getChannels = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.chatClient.getChannels(filter)];
            });
        });
    };
    return ChatService;
}());
exports.default = ChatService;
//# sourceMappingURL=ChatService.js.map